export const IconTaskDone = () => {
    return (
        <svg width='180' height='154' viewBox='0 0 180 154' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <desc>Created with Pixso.</desc>
            <defs />
            <path
                id='Vector'
                d='M156.52 80.47C156.52 98.74 149.09 115.21 137.18 127.05C125.52 138.75 109.38 145.83 91.57 145.83C73.9 145.83 57.75 138.62 45.97 127.05C34.06 115.21 26.63 98.74 26.63 80.47C26.63 44.32 55.71 15.11 91.57 15.11C127.44 15.11 156.52 44.44 156.52 80.47Z'
                fill='#EAEEF9'
                fillOpacity='1.000000'
                fillRule='nonzero'
            />
            <path
                id='Vector'
                d='M156.14 32.35C156.14 35.26 153.79 37.63 150.89 37.63C147.99 37.63 145.63 35.26 145.63 32.35C145.63 29.44 147.99 27.08 150.89 27.08C153.79 27.08 156.14 29.44 156.14 32.35Z'
                fill='#EAEEF9'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M162.16 13.44C162.16 15.43 160.56 17.04 158.57 17.04C156.59 17.04 154.99 15.43 154.99 13.44C154.99 11.45 156.59 9.83 158.57 9.83C160.56 9.83 162.16 11.45 162.16 13.44Z'
                fill='#EAEEF9'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M32.26 33.9C32.26 35.88 30.66 37.5 28.68 37.5C26.7 37.5 25.09 35.88 25.09 33.9C25.09 31.91 26.7 30.29 28.68 30.29C30.66 30.29 32.26 31.91 32.26 33.9Z'
                fill='#EAEEF9'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M13.43 100.28C13.43 103.98 10.45 106.97 6.77 106.97C3.09 106.97 0.11 103.98 0.11 100.28C0.11 96.59 3.09 93.59 6.77 93.59C10.45 93.59 13.43 96.59 13.43 100.28Z'
                fill='#EAEEF9'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M137.18 46.25L137.18 127.05C125.52 138.75 109.38 145.83 91.57 145.83C73.9 145.83 57.75 138.62 45.97 127.05L45.97 46.25L137.18 46.25Z'
                fill='#FFFFFF'
                fillOpacity='1.000000'
                fillRule='nonzero'
            />
            <g opacity='0.500000'>
                <path
                    id='Vector'
                    d='M75.34 69.56L93.18 87.49L87.12 93.58L69.27 75.66L75.34 69.56Z'
                    fill='#979FAF'
                    fillOpacity='1.000000'
                    fillRule='evenodd'
                />
            </g>
            <g opacity='0.500000'>
                <path
                    id='Vector'
                    d='M81.19 87.4L107.82 60.65L113.89 66.75L87.26 93.5L81.19 87.4Z'
                    fill='#979FAF'
                    fillOpacity='1.000000'
                    fillRule='evenodd'
                />
            </g>
            <path
                id='Vector'
                d='M68.26 104.53L114.89 104.53L114.89 110.45L68.26 110.45L68.26 104.53Z'
                fill='#D5DAE5'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M68.26 117.52L114.89 117.52L114.89 123.44L68.26 123.44L68.26 117.52Z'
                fill='#D5DAE5'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
            <path
                id='Vector'
                d='M79.66 130.65L103.49 130.65L103.49 136.57L79.66 136.57L79.66 130.65Z'
                fill='#D5DAE5'
                fillOpacity='1.000000'
                fillRule='evenodd'
            />
        </svg>
    );
};
